export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'
export const SET_TITLE = 'SET_TITLE'
export const SET_AUTO_HIDE = 'SET_AUTO_HIDE'
export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_NOTIFICATION_TYPE = 'SET_NOTIFICATION_TYPE'
export const RESET_DATA = 'RESET_DATA'
